/**
 * Detect clicks on a react-select menu so a calendar popper (DatePicker, DateRangePicker)
 * does not treat selecting a year/month from a portaled menu as an outside click. The
 * year/month `Choice` controls use `menuInPortal`, which renders the menu into
 * `document.body` — outside the popper's clickRef.
 */
export function isReactSelectMenuClick(target: Element): boolean {
  return Boolean(
    target.closest(
      '[role="option"], [role="listbox"], [class*="eag--choice__menu"], [class*="eag--choice__option"]'
    )
  );
}
